<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-07 20:04:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 19:12:07
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "Village",
};
</script>
